import React, {Component} from 'react';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import SideNav from './Nav/SideNav';
import BreadcrumbMaker from './BreadcrumbMaker';
import Page404 from './Page404'
import $ from 'jquery'
import MarkdownRenderer from './MarkdownRenderer';

export default class App extends Component {

    constructor() {
        super();
        this.state = { markdown: '' };
        this.navData = new SideNav().getList();
    }

    componentWillMount() {
        if (window.location.pathname == "/") {
            fetch("/docs/content.md").then(res => res.text()).then(text => this.setState({ markdown: text }));
        } else if (null == this.navData[window.location.pathname]) {
            this.setState({markdown: "**Page Not Found**"});
            return ;
        } else {
            fetch(window.location.pathname + ".md").then(res => res.text()).then(text => this.setState({ markdown: text }));
        }

        $.getScript("/assets/js/documentation-2.js", function(){});

        if (window.location.href.includes("#")) {

            setTimeout(function () {
                window.location.href = window.location.href;
            }, 1000)
        }
    }

    componentDidMount() {

    }

    render() {

        if (null == this.navData[window.location.pathname] && window.location.pathname != "/") {
            return <Page404 />
        }

        const { markdown } = this.state;

        return (
            <div>
                <div className="main-wrapper">
                    <Header />
                    <section className="custom-documentation-section">
                        <div className="documentation-mobile-toggle">
                            <h5>Docs Menu</h5>
                            <div className="dmt-button">
                                <i className="fa-regular fa-chevrons-down"></i>
                            </div>
                        </div>
                        <div className="d-flex">

                            <SideNav />

                            <div className="doc-arrodian-toggle dct2">
                                <i className="fa-solid fa-angles-right"></i>
                            </div>

                            <div className="conentSection px-0">
                                <div className="panelContainer">
                                    <div id="getting_started" className="panel" style={{display: 'block'}}>
                                        <div className="tab-content-wrap">

                                            <BreadcrumbMaker data={this.navData} />
                                            <MarkdownRenderer markdown={markdown} />

                                            <section className="cta-subscribe mt-5" style={{display:'none'}}>
                                                <div
                                                    className="cta-gradient ptb-60 position-relative rounded-custom">
                                                    <div className="row justify-content-center">
                                                        <div className="col-lg-10 col-md-10">
                                                            <div
                                                                className="subscribe-info-wrap text-center position-relative z-2">
                                                                <div className="section-heading sec-cta">
                                                                    <h2>Get started for FREE</h2>
                                                                    <p>Create your APIs easily by saving up to
                                                                        65% time on
                                                                        development. </p>
                                                                </div>
                                                                <div className="action-btns text-center pt-4">
                                                                    <a target="_blank"
                                                                       href="https://cloud.syncloop.com/"
                                                                       className="btn get_ct_btn me-lg-1 me-sm-3">Get
                                                                        started for
                                                                        FREE</a>
                                                                    <a href="pricing.html"
                                                                       className="btn gt-outline">View Pricing &
                                                                        Plans</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>



                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <Footer />
                </div>
            </div>
        )
    }
}
